import type { ComponentType, ElementType, ReactElement, Ref } from "react";

import { Tree } from "../treePrimitive";
import type {
  ArboristTreeApi,
  TreeNodeData,
  TreeNodeRenderProps,
} from "../treeTypes";

type DesignSystemTreeProps<T extends TreeNodeData = TreeNodeData> = {
  data: TreeNodeData[];
  openByDefault: boolean;
  selectionFollowsFocus?: boolean;
  disableMultiSelection?: boolean;
  rowHeight: number;
  indent: number;
  overscanCount: number;
  width: number;
  height: number;
  treeRef?: Ref<ArboristTreeApi<T> | null>;
  /** Omit to use arborist's built-in container (avoids duplicate TreeApi context). */
  renderContainer?: ElementType;
  onToggle?: (id: string) => void;
  children: ComponentType<TreeNodeRenderProps<T>>;
};

function DesignSystemTree<T extends TreeNodeData>({
  data,
  openByDefault,
  selectionFollowsFocus,
  disableMultiSelection,
  rowHeight,
  indent,
  overscanCount,
  width,
  height,
  treeRef,
  renderContainer,
  onToggle,
  children: Node,
}: DesignSystemTreeProps<T>): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const TreeAny = Tree as any;
  return (
    <TreeAny
      ref={treeRef as Ref<unknown>}
      data={data}
      openByDefault={openByDefault}
      selectionFollowsFocus={selectionFollowsFocus}
      disableMultiSelection={disableMultiSelection}
      rowHeight={rowHeight}
      indent={indent}
      overscanCount={overscanCount}
      width={width}
      height={height}
      {...(renderContainer != null ? { renderContainer } : {})}
      {...(onToggle != null ? { onToggle } : {})}
    >
      {Node}
    </TreeAny>
  );
}

export default DesignSystemTree;
export { Tree } from "../treePrimitive";
